// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Report by ID — heading only; keep original card/search layout */

.reportId-page {
  margin-top: 67px;
  padding: 0 16px 20px;
  box-sizing: border-box;
}

.reportId-page .headS {
  margin: 0 0 12px 8px;
  color: #0f172a;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.3;
}

.reportId-page .reports {
  color: #0f172a;
  text-decoration: none;
  font-weight: 700;
  font-size: 24px;
}

.reportId-page .reports:hover {
  color: #07a6ef;
}

.reportId-page .crumbSep {
  margin: 0 6px;
  color: #94a3b8;
  font-weight: 600;
  font-size: 20px;
}

.reportId-page .reporter {
  color: #0f172a;
  font-weight: 700;
  font-size: 24px;
}

.reportId-page .reportsNote {
  color: #07a6ef;
  text-decoration: none;
  font-size: 14px;
  font-weight: 700;
}

.reportId-page .reportdCompleteS {
  margin: 0 auto;
}

@media (max-width: 600px) {
  .reportId-page {
    margin-top: 50px;
    padding: 0 8px 16px;
  }

  .reportId-page .headS,
  .reportId-page .reports,
  .reportId-page .reporter {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Css/ReportId.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;;IAGE,eAAe;EACjB;AACF","sourcesContent":["/* Report by ID — heading only; keep original card/search layout */\r\n\r\n.reportId-page {\r\n  margin-top: 67px;\r\n  padding: 0 16px 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.reportId-page .headS {\r\n  margin: 0 0 12px 8px;\r\n  color: #0f172a;\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n  line-height: 1.3;\r\n}\r\n\r\n.reportId-page .reports {\r\n  color: #0f172a;\r\n  text-decoration: none;\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n}\r\n\r\n.reportId-page .reports:hover {\r\n  color: #07a6ef;\r\n}\r\n\r\n.reportId-page .crumbSep {\r\n  margin: 0 6px;\r\n  color: #94a3b8;\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n}\r\n\r\n.reportId-page .reporter {\r\n  color: #0f172a;\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n}\r\n\r\n.reportId-page .reportsNote {\r\n  color: #07a6ef;\r\n  text-decoration: none;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n}\r\n\r\n.reportId-page .reportdCompleteS {\r\n  margin: 0 auto;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .reportId-page {\r\n    margin-top: 50px;\r\n    padding: 0 8px 16px;\r\n  }\r\n\r\n  .reportId-page .headS,\r\n  .reportId-page .reports,\r\n  .reportId-page .reporter {\r\n    font-size: 20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
